module.exports = __webpack_public_path__ + "img/IRN.b21cfc87.svg";